import React, { useState } from 'react';
import {
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    Typography,
} from '@material-ui/core/';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import styles from 'styles/components/notifierDialog.module.scss';

const DialogTitle = (props) => {
    const { children } = props;
    return (
        <MuiDialogTitle className={styles.title}>
            <Typography variant="subtitle1" className={styles.h6}>
                {children}
            </Typography>
        </MuiDialogTitle>
    );
};

DialogTitle.propTypes = {
    children: PropTypes.any,
};

const NotifierDialog = (props) => {
    const { notification, handleNotificationDismiss, handleSessionWarning } = props;

    const [open] = useState(true);

    const showErrors = () => {
        const errors = notification.errors;
        if (errors && errors.length > 0) {
            const output = errors.map((error) => {
                const key = Object.keys(error)[0];
                return <li key={`${key} - ${error[key]}`}>{`${key} - ${error[key]}`}</li>;
            });
            return <ul>{output}</ul>;
        }
        return null;
    };

    const actions = () => {
        switch (notification.status) {
            case 'ok_and_dismiss':
                return (
                    <Button
                        id="dismiss_notification"
                        onClick={handleNotificationDismiss}
                        color="primary"
                        autoFocus
                        variant="contained"
                        size="small"
                    >
                        Fechar
                    </Button>
                );
            // deepcode ignore DuplicateCaseBody: <please specify a reason of ignoring this>
            case 'error':
                return (
                    <Button
                        id="dismiss_notification"
                        onClick={handleNotificationDismiss}
                        color="primary"
                        autoFocus
                        variant="contained"
                        size="small"
                    >
                        Fechar
                    </Button>
                );
            case 'show_session_expire_warning':
                return (
                    <>
                        <Button
                            id="session_expire"
                            onClick={handleSessionWarning}
                            color="primary"
                            variant="contained"
                            size="small"
                        >
                            Encerrar sessao
                        </Button>
                        <Button
                            id="session_extend"
                            className={styles.buttonLeft}
                            onClick={handleSessionWarning}
                            color="primary"
                            autoFocus
                            variant="contained"
                            size="small"
                        >
                            Continuar sessao
                        </Button>
                    </>
                );
            case 'show_logout_idle_message':
                return (
                    <Button
                        id="session_logout"
                        onClick={handleSessionWarning}
                        color="primary"
                        autoFocus
                        variant="contained"
                        size="small"
                    >
                        Fechar
                    </Button>
                );
            case 'post_insert_ad_register':
                return (
                    <>
                        <Button
                            className="goToLogin"
                            color="primary"
                            onClick={handleNotificationDismiss}
                            variant="contained"
                            size="small"
                        >
                            Login
                        </Button>
                        <Button
                            className="goToRegister"
                            variant="contained"
                            size="small"
                            color="primary"
                            onClick={handleNotificationDismiss}
                        >
                            Cadastro
                        </Button>
                    </>
                );
            case 'post_insert_ad_logged_in':
                return (
                    <>
                        <Button
                            className="goToAd"
                            variant="contained"
                            size="small"
                            color="primary"
                            onClick={handleNotificationDismiss}
                        >
                            Ver anuncio
                        </Button>
                        <Button
                            className={styles.buttonLeft}
                            variant="contained"
                            size="small"
                            color="primary"
                            onClick={handleNotificationDismiss}
                        >
                            Fechar
                        </Button>
                    </>
                );
            case 'confirm':
                return (
                    <>
                        <Button
                            id="cancelled"
                            className={styles.buttonLeft}
                            variant="contained"
                            size="small"
                            color="primary"
                            onClick={handleNotificationDismiss}
                        >
                            Cancelar
                        </Button>
                        <Button
                            id="confirmed"
                            variant="contained"
                            size="small"
                            color="primary"
                            onClick={handleNotificationDismiss}
                        >
                            Confirmar
                        </Button>
                    </>
                );
            case 'redirect':
                return <div />;
            default:
                return null;
        }
    };

    if (notification.status !== '') {
        return (
            <Dialog className={styles.root} open={open} fullWidth>
                <DialogTitle>{notification.title}</DialogTitle>
                <DialogContent className={styles.content}>
                    <div>{notification.message}</div>
                    {showErrors()}
                </DialogContent>
                <DialogActions className={styles.actions}>{actions()}</DialogActions>
            </Dialog>
        );
    }
    return null;
};

NotifierDialog.propTypes = {
    notification: PropTypes.object.isRequired,
    handleNotificationDismiss: PropTypes.func,
    handleSessionWarning: PropTypes.func,
};

export default React.memo(NotifierDialog);
